<!--
* UIID: 
* UI Name: Folder Table List
* Modify Date: 2020/10/07
-->
<template>
  <v-card height="100%" class="folder-card-section">
    <v-card-text>
      <v-row class="custom-form-control">
        <v-col cols="12" md="3" lg="2" class="pt-0 pb-0">
            <div class="title-grid-folder">
            <v-label class>{{$t('lbl.mapBuilder.loadFile.fileSection')}}</v-label>
          </div>
        </v-col>
        <!-- Search control -->
        <v-col
          cols="12"
          md="9"
          lg="10"
          class="comm-header-col date-query-section pt-0 pb-0 text-right"
        >
          <div class="d-inline-flex">
            <v-text-field
              v-model="search"
              append-icon="fa fa-search"
              placeholder="Find by file name"
              hide-details
              dense
              solo
              class="search-button mt-0"
              height="30"
            ></v-text-field>
          </div>
          <div class="d-inline-flex">
            <v-select
              label="Type"
              v-model="searchBy"
              :items="statusList"
              hide-details
              dense
              solo
              class="custom-selectbox"
              :menu-props="{offsetY: true,}"
            ></v-select>
          </div>
          <div class="d-inline-flex btn-control">
            <v-btn class="btn btn-search" color="primary">
              <v-icon x-small class="mr-2">fa fa-plus</v-icon>Add File
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <!-- Grid table page class="flat-file-control-section" -->
      <v-row>
        <v-col class="page-control-content page-control-bg folder-pagination">
          <v-row>
            <v-col lg="12" md="12">
              <v-row>
                <v-col class="page-control-bg" cols="12">
                  <div class="page-showing">
                    <v-label>{{$t('lbl.common.showing')}} {{this.itemsPerPage}} {{$t('lbl.common.of')}} {{this.listData.length}}</v-label>
                  </div>
                  <div class="custom-pagi-selectbox">
                    <v-select
                      v-model="itemsPerPage"
                      hide-details
                      dense
                      solo
                      :items="itemShow"
                      class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                    ></v-select>
                  </div>
                  <div class="page-count flat-table-pagination">
                    <v-pagination v-model="page" :length="pageCount"></v-pagination>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
       <!-- Table view -->
      <v-row class="grid-file-view ml-0 mr-0">
        <v-col cols="12" class="file-view-wrap">
        <v-data-table
          :headers="headers"
          :items="listData"
          class="list-table list-table-small"
          item-key="id"
          pb-2
          :hide-default-footer="true"
          :fixed-header="true"
          :height = tableHeight
          :page.sync="page"
          :items-per-page="itemsPerPage"
          @page-count="pageCount = $event"
        >

          <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.ROWID" v-show="(searchBy==''||searchBy==item.USR_FILE_TYPE) && findSearchFile(item)">
                  <td class="sender-col">{{ item.USR_FILE_NAME }}</td>
                  <td class="receiver-col">{{ item.USR_FILE_TYPE }}</td>
                  <td class="message-col">{{ item.USR_FILE_TYPE }}</td>
                  <td class="message-format-col">{{ item.USR_FILE_SIZE }}</td>
                  <td class="message-format-col">{{ item.USR_FILE_CRE_DT}}</td>
                  <td class="date-col">{{ item.USR_FILE_UPD_DT }}</td>
                </tr>
              </tbody>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
        </v-data-table>
      </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import $ from "jquery";
export default {
  components: {
    
  },

  props: {
    items: {
      default: Array
    },
    listData:{
       default: Array
    },
    resetPage:{
      default: String
    }
  },

  data: () => ({
    searchBy: '',
    search: '',
    isCreated: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 24,
    // listData: Array,
    insertItem: {
      partner: "",
      contract: "",
      email: "",
      email_f: "",
      email_t: "",
      status: "",
      remark: ""
    },
    itemShow:[
      {text:"Show 24" , value:24},
      {text:"Show 36" , value:36},
      {text:"Show 60" , value:60},
      {text:"Show 90" , value:90},
      {text:"Show 120" , value:120}
    ],
    tableHeight:  610,
    searchPartner: "",
    searchStatus: "",
     name: 'inbox_bkg_confirm_hlcu',
          type: 'D',
          ext: 'folder',
          size: '(2 Files)',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
    headers: [
        { text: 'Name', value: 'USR_FILE_NAME'},
        { text: 'Type', value: 'USR_FILE_TYPE'},
        { text: 'Extension', value: 'USR_FILE_TYPE'},
        { text: 'Size', value: 'USR_FILE_SIZE'},
        { text: 'Created Date', value: 'USR_FILE_CRE_DT'},
        { text: 'Modify Date', value: 'USR_FILE_UPD_DT'},
      ],
    statusList: [
      { text: "All", value: "" },
      { text: "txt", value: "txt" },
      { text: "cpp", value: "cpp" },
      { text: "json", value: "json" },
      { text: "xml", value: "xml" },
      { text: "biz", value: "biz" }
    ],
    inputDisplay: "d-none"
  }),

  created() {
    // this.listData = this.items;
    this.isCreated = true;
  },
  watch: {
    resetPage:{
      immediate:true,
      handler(){
        this.page=1;
      }
    }
  },
  methods: {
    findSearchFile(item) {
        if(this.search != '') {
          // for(let key in item) {
          if(item['USR_FILE_NAME'].toLowerCase().indexOf(this.search.toLowerCase()) > -1) {
            return true;
          }
          return false;
        } else {
          return true;
        }
      },
  }
};
</script>
<style >
.theme--dark .file-view-wrap{
    background: #232329;
    border: 1px solid transparent;
    border-radius: 3px;
    padding: 15px 15px 10px 15px !important;
}
.theme--light .file-view-wrap{
    background: #EDF3FC;
    border: 1px solid transparent;
    border-radius: 3px;
    padding: 15px 15px 10px 15px !important;
}
</style>